import { CeoSubmittedFormType } from 'models/CeoSubmittedForm';
import {
  CeoSubmittedFormListResponse,
  CeoSubmittedFormPayload,
  CeoSubmittedFormResponse,
} from 'types/services/CeoSubmittedForm';
import axiosInstance from 'utils/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/ceosubmittedform`;
class CeoSubmittedForm {
  async getByEnrollmentId(
    enrollmentId: string
  ): Promise<CeoSubmittedFormResponse> {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/getByEnrollmentId/${enrollmentId}`
    );

    return data;
  }

  async createCeoSubmittedForm(
    payload: CeoSubmittedFormPayload
  ): Promise<CeoSubmittedForm> {
    console.log(payload);

    const { data } = await axiosInstance.post(
      `${BASE_URL}/createCeoSubmittedForm`,
      payload
    );

    return data;
  }
}

export const CeoSubmittedFormInstance = new CeoSubmittedForm();
